import { render, staticRenderFns } from "./ServiceEndpointPermission.vue?vue&type=template&id=a8776366&scoped=true"
import script from "./ServiceEndpointPermission.vue?vue&type=script&lang=js"
export * from "./ServiceEndpointPermission.vue?vue&type=script&lang=js"
import style0 from "./ServiceEndpointPermission.vue?vue&type=style&index=0&id=a8776366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8776366",
  null
  
)

export default component.exports